export const CREATE_PROPERTY_RECORD_ID = '__create_resource_property__::new'
export const CREATE_FORM_RECORD_ID = '__create_resource_form__::new'
